function isLocalStorageSupport() {
    try {
        var isSupport = "localStorage" in window && window["localStorage"] !== null;
        if (isSupport) {
            localStorage.setItem("__test", "1");
            localStorage.removeItem("__test");
        }
        return isSupport;
    }
    catch (e) {
        return false;
    }
}
function isSessionStorageSupport() {
    try {
        var isSupport = "sessionStorage" in window && window["sessionStorage"] !== null;
        if (isSupport) {
            sessionStorage.setItem("__test", "1");
            sessionStorage.removeItem("__test");
        }
        return isSupport;
    }
    catch (e) {
        return false;
    }
}
var memeryStorage = {
    length: 0,
    data: {},
    getItem: function (key) {
        return this.data[key];
    },
    key: function (index) {
        return null;
    },
    removeItem: function (key) {
        delete this.data[key];
    },
    setItem: function (key, value) {
        this.data[key] = value;
    },
    clear: function () {
        this.data = {};
    },
};
export function getStorage() {
    if (isLocalStorageSupport) {
        return window.localStorage;
    }
    else if (isSessionStorageSupport) {
        return window.sessionStorage;
    }
    return memeryStorage;
}
